<template>
  <Menubar class="layout-topbar pl-4 pr-4 w-full">
    <template #start>
      <div class="flex">
        <!-- <div v-if="currentRouteName === workingSpace" class="icon-place"></div>
        <div v-if="currentRouteName !== workingSpace" @click="menuClickEvent(workingSpacePath)"
          class="mx-2 p-0 flex align-items-center">
          <span class="material-icons mouse-pointer icon-animation p-2">home</span>
        </div>
        <div v-if="currentRouteName !== workingSpace" @click="router.go(-1)" class="mx-2 p-0 flex align-items-center">
          <span class="material-icons mouse-pointer icon-animation p-2">arrow_back</span>
        </div>
        <div class="mx-2 p-0">
          <span>
            {{ displayedName(currentRouteName) }}
          </span>
        </div> -->
        <div class="align-self-center py-0" @click="menuClickEvent(workingSpacePath)">
          <span class="site-name-class">{{ siteName }}</span>
        </div>
      </div>
    </template>
    <template #end>
      <div class="flex justify-content-between">
        <div class="ml-auto mr-3 flex align-items-center justify-content-around">
          <div class="px-5 py-0" @click="menuClickEvent(workingSpacePath)">
            <span class="structure-class">{{ structureName }}</span>
          </div>
        </div>
        <!-- <Avatar image="https://i.pravatar.cc/200?img=51" class="mr-3" size="large" shape="circle" />-->
        <user-dropdown :workingSpacePath="workingSpacePath" /> 
      </div>
    </template>
  </Menubar>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { useRouter, useRoute } from 'vue-router'; // Importation des hooks
import commonVars from "@/common/common-var";
import { Utils } from "@/common/utils";
import UserDropdown from './user-dropdown/user-dropdown.vue';

export default defineComponent({
  name: "NavbarApp",
  components: {
    UserDropdown
  },
  props: {
    exclude: { type: Array, default: () => [] },
  },
  setup() {
    const router = useRouter(); // Récupère l'instance du routeur
    const route = useRoute(); // Récupère l'instance de la route actuelle

    const profilDisplayName = Utils._pageMap.get(commonVars.PROFIL);
    const profil = commonVars.PROFIL;
    const profilPath = commonVars.PROFIL_PATH;
    const workingSpacePath = commonVars.WORKINGSPACE_PATH;
    const workingSpace = commonVars.HOME;
    const structureName = commonVars.STRUCTURE_NAME;
    const siteName = commonVars.SITE_NAME;

    // Fonction pour afficher le nom de la page en fonction de son nom
    const displayedName = (name: string): string | undefined => {
      return Utils._pageMap.get(name);
    };

    // Computed pour obtenir le nom de la route actuelle
    const currentRouteName = computed(() => route.name?.toString() ?? '');

    // Fonction pour gérer le clic sur le menu et naviguer vers une autre route
    const menuClickEvent = (routeName: string) => {
      router.push({ path: routeName });
    };

    return {
      router,
      route,
      profilDisplayName,
      profil,
      profilPath,
      workingSpacePath,
      workingSpace,
      structureName,
      siteName,
      displayedName,
      currentRouteName,
      menuClickEvent
    };
  },
});
</script>

<style src="./navbar-app.scss" lang="scss" scoped />
